<template>
   <!-- <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, user-scalable=yes"> -->
  <router-view />
</template>

<style lang="scss">
html, body, #app {
  width: 100%;
  height: 100%;
  overflow-x: visible;
}
 
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>
<style>
/* 不加 scoped，让样式全局生效 */
.w-e-text-container code {
  background-color: #f0fff0 !important;
  color: #07ce07 !important;
  padding: 2px 4px !important;
  border-radius: 4px !important;
  font-family: monospace !important;
}

.w-e-text-container pre code {
  background-color: #002b36 !important;
  color: #839496 !important;
  padding: 10px !important;
  border-radius: 4px !important;
  display: block !important;
  overflow-x: auto !important;
}
.tag-button {
  height: 8%;
  padding: 10px; /* 增加内边距 */
  margin-bottom: 10px; /* 增加底部外边距 */
  margin-right: 10px; /* 增加右侧外边距 */
}
.w-e-text-container [data-slate-editor] p {
  margin: 0 !important;
}
</style>